<template>
  <div class="vehicle-tyre-configuration-main">

    <div class="config-box"> 
       
      <div style="display: flex;">
        <div class="legend">
          <p>Legend:</p>
          <div style="display: flex;">
            <div class="selected-box"></div>
            <p style="padding: 3px;">Selected</p>
          </div>
          <div style="display: flex;">
            <div class="saved-box"></div>
            <p style="padding: 3px;">Saved</p>
          </div>
          <div style="display: flex;">
            <div class="spare-box"><p style="font-weight: bold; margin-top: -7px; text-align: center;">S</p></div>
            <p style="padding: 3px;">Spare</p>
          </div>
        </div>

        <div class="box_left">
          <p style="margin-top: 105px; color: #0000FF; font-weight: bold;"> Left </p>
          <div>
            <div :class="`index_${item-1}`" v-for="item of 10" :key="item"></div>
          </div>        
          <div><div :class="`index_${(item-1)+10}`" v-for="item of 10" :key="item"></div></div>        
          <div><div :class="`index_${(item-1)+20}`" v-for="item of 10" :key="item"></div></div>        
          <div><div :class="`index_${(item-1)+30}`" v-for="item of 10" :key="item"></div></div>        
          <div><div :class="`index_${(item-1)+40}`" v-for="item of 10" :key="item"></div></div>        
        </div>
      </div>

      <div class="middle-box">
        <div class="front-box">
          <div class="index2_0"></div>
        </div>

        <div class="spare-div">
          <div class="spare-box">
            <p class="front-title">Front</p>
            <div class="spare">
              <div class="index_100" style="color"><p>S</p></div>
            </div>
            <div class="spare">
              <div class="index_101"><p>S</p></div>
            </div>
            <div class="spare">
              <div class="index_102"><p>S</p></div>
            </div>
            <div class="spare">
              <div class="index_103"><p>S</p></div>
            </div>
            <p class="rear-title">Rear</p>
          </div>
        </div>

        <div class="rear-box">
          <div class="index2_1"></div>
        </div>
      </div>

      <div style="display: flex;">
        <div class="right-box">
          <div>
            <div :class="`index_${(item-1)+50}`" v-for="item of 10" :key="item"></div>
          </div>  
          <div><div :class="`index_${(item-1)+60}`" v-for="item of 10" :key="item"></div></div>  
          <div><div :class="`index_${(item-1)+70}`" v-for="item of 10" :key="item"></div></div>  
          <div><div :class="`index_${(item-1)+80}`" v-for="item of 10" :key="item"></div></div>  
          <div><div :class="`index_${(item-1)+90}`" v-for="item of 10" :key="item"></div></div>  

          <p style="margin-top: 105px; color: #0000FF; font-weight: bold; margin-left: 15px;"> Right </p>
        </div>

        <div style="width: 125px; display: grid; justify-content: center;">
          <button style="width: 75px; height: 35px;" :disabled="viewMode">+</button>
          <button style="width: 75px; height: 35px;" :disabled="viewMode">
            <img src="https://image.flaticon.com/icons/png/512/178/178880.png" height="15" width="15">
          </button>
          <button style="width: 75px; height: 35px;" :disabled="viewMode">-</button>
          <button style="width: 75px; height: 35px;" :disabled="viewMode">
            <img src="https://www.flaticon.com/svg/static/icons/svg/3208/3208682.svg" height="15" width="15">
          </button>
        </div>
      </div>
    </div>

    <div class="task-section">
      <span>No Naming</span>   
      <div class="flex-row">
        <Input placeholder="Serial No" :inputValue.sync="data.serialno" :isDisabled="viewMode" :isRequired="true" style="padding-right: 10px;"/>  
        <Input placeholder="Model" :inputValue.sync="data.tyre_configuration_model" :isDisabled="viewMode" />  
      </div>

      <div class="flex-row">
        <Input placeholder="Size" :inputValue.sync="data.size" :isDisabled="viewMode" style="padding-right: 10px;"/>  
        <Dropdown placeholder="Manufacturer" :selectedObject.sync="data.selectedmanufacturer" :items="data.manufacturerItems"
          :search.sync="data.manufacturerSearch" :isDisabled="viewMode" /> 
      </div>

      <div class="flex-row">
        <DateTimePicker title="Mfg Date" :showTime="false" style="justify-content: flex-start; margin-right: 15px; width: 100%;" :value.sync="data.mfgdate" :isDisabled="viewMode" />
        <Dropdown placeholder="Made In" :selectedObject.sync="data.selectedMadeIn_TyreConf" :items="data.madein_tyreconf_Items"
          :search.sync="data.madein_tyreconf_Search" :isDisabled="viewMode"/> 
      </div>

      <div class="flex-row">
        <DateTimePicker title="Date Change" :showTime="false" style="justify-content: flex-start; margin-right: 15px; width: 100%;" :value.sync="data.datechange" 
          :isDisabled="viewMode" />
        <RemarksBox title="Remarks" maxLength="200" :text.sync="data.tyre_configuration_remark" :isDisabled="viewMode"/>
      </div>
    </div>

    <Tabulator class="tyre-tabulator" style="height: unset" :tableData="data.tyreConfigurationData" :multiSelect="1" :selectedRow.sync="selectedTyre"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Tabulator from '@/components/Tabulator.vue';
import RemarksBox from '@/components/RemarksBox.vue';

export default {
  components: {
    Input, Dropdown, DateTimePicker, Tabulator, RemarksBox
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },
    lastIndex: { type: Number, default: null },
    lastColor: { type: String, default: null },

    selectedTyre: { type: Array, default: function() { return [] } },
  },
  methods: {
  },
  mounted() {
    if (this.viewMode) {
      if(this.data.tyreIndexData[0] == null || this.data.tyreIndexData[0] == 'T'){
        for(var x = 0; x < 104; x++){
          document.getElementsByClassName(`index_${x}`)[0].style.backgroundColor = 'white';
          document.getElementsByClassName(`index_${x}`)[0].style.borderColor = 'white';
          document.getElementsByClassName(`index2_0`)[0].style.backgroundColor = 'white';
          document.getElementsByClassName(`index2_1`)[0].style.backgroundColor = 'white';
          document.getElementsByClassName(`index2_0`)[0].style.borderColor = 'white';
          document.getElementsByClassName(`index2_1`)[0].style.borderColor = 'white';
          document.getElementsByClassName(`index_100`)[0].style.color = 'white';
          document.getElementsByClassName(`index_101`)[0].style.color = 'white';
          document.getElementsByClassName(`index_102`)[0].style.color = 'white';
          document.getElementsByClassName(`index_103`)[0].style.color = 'white';          
        }
      }
      else {
        this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${i.TyreIndex}`)[0].style.backgroundColor = 'orange' } );
        for(var x = 0; x < 104; x++){
          var elem = document.getElementsByClassName(`index_${x}`)[0];
          var theCSSprop = window.getComputedStyle(elem, null).getPropertyValue("background-color");

          if(theCSSprop.includes('rgb(255, 255, 255)')){
          //without configuration
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.backgroundColor = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.borderColor = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.backgroundColor = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.backgroundColor = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.borderColor = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.borderColor = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_100`)[0].style.color = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_101`)[0].style.color = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_102`)[0].style.color = 'white' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_103`)[0].style.color = 'white' } );
          }
          else{
            //with configuration
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.backgroundColor = 'grey' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.borderColor = 'grey' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.backgroundColor = 'grey' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.backgroundColor = 'grey' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.borderColor = 'grey' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.borderColor = 'grey' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_100`)[0].style.color = 'black' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_101`)[0].style.color = 'black' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_102`)[0].style.color = 'black' } );
            this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_103`)[0].style.color = 'black' } )
          }
        }
      }
    }
    else {
      //edit or new mode
      this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${i.TyreIndex}`)[0].style.backgroundColor = 'orange' } );
      for(var x = 0; x < 104; x++){
        var elem = document.getElementsByClassName(`index_${x}`)[0];
        var theCSSprop = window.getComputedStyle(elem, null).getPropertyValue("background-color");

        if(theCSSprop.includes('rgb(255, 255, 255)')){
          //without configuration
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.backgroundColor = 'white' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.borderColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.backgroundColor = 'white' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.backgroundColor = 'white' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.borderColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.borderColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_100`)[0].style.color = 'black' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_101`)[0].style.color = 'black' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_102`)[0].style.color = 'black' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_103`)[0].style.color = 'black' } );
        }
        else{
          //with configuration
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.backgroundColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_${x}`)[0].style.borderColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.backgroundColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.backgroundColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_0`)[0].style.borderColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index2_1`)[0].style.borderColor = 'grey' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_100`)[0].style.color = 'black' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_101`)[0].style.color = 'black' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_102`)[0].style.color = 'black' } );
          this.data.tyreIndexData.map((i) => { return document.getElementsByClassName(`index_103`)[0].style.color = 'black' } )
        }
      }
      
    }
  },
  watch: {
    selectedTyre: function() {
      if(this.selectedTyre.length >= 1){
        if(this.lastIndex)
          document.getElementsByClassName(`index_${this.lastIndex}`)[0].style.backgroundColor = `${this.lastColor}`;  

        this.data.serialno = this.selectedTyre[0].SerialNo ? this.selectedTyre[0].SerialNo : '';
        this.data.tyre_configuration_model = this.selectedTyre[0].Model ? this.selectedTyre[0].Model.trim() : '';
        this.data.size = this.selectedTyre[0].TyreSize ? this.selectedTyre[0].TyreSize.trim() : '';
        this.data.manufacturerSearch = this.selectedTyre[0].Manufacturer ? this.selectedTyre[0].Manufacturer.trim() : '';
        this.data.mfgdate = new Date(this.selectedTyre[0]['MfgDate']);
        this.data.madein_tyreconf_Search = this.selectedTyre[0].MadeIn ? this.selectedTyre[0].MadeIn.trim() : '';
        this.data.datechange = new Date(this.selectedTyre[0]['DateChange']);
        this.data.tyre_configuration_remark = this.selectedTyre[0].Remark1 ? this.selectedTyre[0].Remark1.trim() : '';

        var elem = document.getElementsByClassName(`index_${this.selectedTyre[0].TyreIndex}`)[0];
        var theCSSprop = window.getComputedStyle(elem, null).getPropertyValue("background-color");
        this.lastColor = theCSSprop.toString();

        document.getElementsByClassName(`index_${this.selectedTyre[0].TyreIndex}`)[0].style.backgroundColor = 'pink';
        this.lastIndex = this.selectedTyre[0].TyreIndex;
      }
      else if (this.selectedTyre.length == 0){
        if(this.lastIndex){
          document.getElementsByClassName(`index_${this.lastIndex}`)[0].style.backgroundColor = `${this.lastColor}`; 
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.config-box{
  display: flex;
  width: 100%;
  height: 250px;
  align-items: center;
  justify-content: center;

  .legend{
  width: 120px; 
  height: calc(100% - 75px); 
  border: 1px solid darkgrey; 
  border-radius: 3px; 
  padding: 5px;
  margin-right: 20px;

    div{
      .selected-box{
        width: 30px; 
        height: 15px; 
        background-color: pink; 
        border-radius: 1px; 
        padding: 5px; margin: 5px 0px;
      }

      .saved-box{
        width: 30px; 
        height: 15px; 
        background-color: orange; 
        border-radius: 1px; 
        padding: 5px; 
        margin: 5px 0px;
      }

      .spare-box{
        width: 30px; 
        height: 15px; 
        background-color:lightgrey; 
        border-radius: 1px; 
        padding: 5px; 
        margin: 5px 0px;
      }
    }
  }

  .box_left{
    width: calc(100% - 120px); 
    padding: 5px; 
    display: flex; 
    justify-content: center;

    div{
      div{
        width: 30px; 
        height: 15px; 
        border: 1px solid grey;
        background-color: white; 
        border-radius: 1px; 
        padding: 5px; 
        margin-top: 5px; 
        margin-left: 15px;
      }
    }
  }

  .middle-box{
    width: 10%; 
    justify-content: center;
    margin-left: 10px;

    .front-box{
      display:flex; 
      width: 100%; 
      justify-content: center;

      div{
        width: 30px; 
        height: 15px; 
        border: 1px solid grey;
        background-color: white; 
        border-radius: 1px; 
        padding: 5px;
      }
    }

    .spare-div{
      display:flex; 
      width: 100%; 
      justify-content: center; 
      margin: 10px 0px;

      .spare-box{
        width: 100px; 
        height: 175px; 
        border: 1px solid darkgrey; 
        border-radius: 3px; 
        text-align: center;

        .front-title{
          color: #0000FF; 
          font-weight: bold;
        }

        .spare{
          display:flex; 
          justify-content: center;

          div{
            width: 30px; 
            height: 15px; 
            border: 1px solid grey;
            background-color: white; 
            border-radius: 1px; 
            padding: 5px; 
            margin: 5px 0px;

            p{
              font-weight: bold; 
              margin-top: -7px;
            }
          }
        }

        .rear-title{
          color: #0000FF; 
          font-weight: bold; 
          margin-top: 10px;
        }
      }
    }

    .rear-box{
      display:flex; 
      width: 100%; 
      justify-content: center;
    
      div{
        width: 30px; 
        height: 15px; 
        border: 1px solid grey;
        background-color: white; 
        border-radius: 1px; 
        padding: 5px;}
    }

  }

  .right-box{
    width: calc(100% - 125px); 
    padding: 5px; 
    display: flex; 
    justify-content: center;

    div{
      div{
        width: 30px; 
        height: 15px; 
        border: 1px solid grey;
        background-color: white; 
        border-radius: 1px; 
        padding: 5px; 
        margin-top: 5px; 
        margin-left: 15px;
      }
    }
  }
}

.flex-row {
  display: flex;
}

.task-section{
  border: 1px solid darkgrey;
  border-radius: 3px;
  margin-top: 10px;
  padding: 15px;

  span{
    margin-top: -26px;
    position: absolute;
    color: chocolate;
    background-color: #ffffffff;
    font-weight: bold;
    padding: 0 5px 0 5px;
    width: auto;
    height: 20px;
  }
}

.tyre-tabulator {
  height: calc(100% - 95px) !important;
}
</style>